import { render, staticRenderFns } from "./disable-widget-dialog.vue?vue&type=template&id=5fa0c834"
import script from "./disable-widget-dialog.vue?vue&type=script&lang=js"
export * from "./disable-widget-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports